var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isProUser)?_c('span',{staticClass:"tag pro-tag is-small is-secondary m-l-5"},[_vm._v("pro")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }